import * as actions from "./actions";

const initialState = {};

export const editModalReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case actions.EDIT_MODAL:
            return {
                loading: true
            };
        case actions.EDIT_MODAL_SUCCESS:
            return {
                loading: false
            };
        case actions.EDIT_MODAL_FAILURE:
            return {
                loading: false
            };
        default:
            return state;
    }
};

export const publishArticleModalReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case actions.EDIT_MODAL:
            return {
                ...state,
                loading: true,
            };
        case actions.EDIT_MODAL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actions.EDIT_MODAL_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export const multimediaModalReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case actions.EDIT_MODAL:
            return {
                ...state,
                loading: true,
            };
        case actions.EDIT_MODAL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actions.EDIT_MODAL_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export const addFilesModalReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case actions.ADD_FILES_MODAL:
            return {
                ...state,
                loading: true,
            };
        case actions.ADD_FILES_MODAL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case actions.ADD_FILES_MODAL_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};